import * as App from '..';
import * as SDK from '../../lib/sdk';
import { countDays } from '../../lib/utils';
export function showNative(cb) {
    if (checkNative()) {
        SDK.Ad.showNative(cb);
    }
    else {
        cb && cb(false);
    }
}
export function checkNative() {
    var wallPostTime = App.storage.get().wallPostTime;
    // 3 дня без рекламы тем кто опубликовал запись на стене
    if (FOR_VK && countDays(wallPostTime) <= 3) {
        return false;
    }
    return SDK.Ad.checkNative();
}
